module.exports = __webpack_public_path__ + "static/media/m1_sf_15.f5a8b64f.png";